<template>
  <el-select
    v-model="upResId"
    clearable
    placeholder="请选择"
    @clear="handleClear"
    ref="selectUpResId"
    @visible-change="treeshow"
  >
    <el-option hidden key="upResId" :value="upResId" :label="upResName">
    </el-option>
    <el-tree
      ref="tree"
      :data="data"
      show-checkbox
      default-expand-all
      node-key="resId"
      highlight-current
      :default-checked-keys="defaultarr"
      @check-change="stateChange"
      :props="defaultProps"
    >
    </el-tree>
  </el-select>
</template>
<script>
export default {
  data() {
    return {
      aa: true,
      defaultarr: [0],
      data: [
        {
          resId: 0,
          label: '全部',
          children: [],
        },
      ],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      upResId: '',
      upid: [],
      upResName: '全部',
      upname: [],
      needValue: [],
      // 叶子节点
      leafNodes: [],
      // 全选节点
      allCheckNodes: [],
    };
  },
  props: { treeData: Array },
  created() {
    this.data[0].children = this.treeData;
  },
  methods: {
    sendSelect() {
      this.$emit('receiveSelect', this.upResId);
    },
    // 只传叶子节点
    sendSelectYezi() {
      this.$emit('receiveSelectPro', this.leafNodes, this.upResId);
    },
    sendSelectstate() {
      this.$emit('receiveSelectstate', this.upResId);
    },

    treeshow(showt) {
      if (showt) {
        this.defaultarr = [0];
      }
    },
    stateChange() {
      // 先取消默认选中的
      this.defaultarr = [];
      // 最后筛选出的数据

      this.needValue = [];

      // 先查出叶子节点
      const leafNodes = this.$refs.tree.getCheckedNodes(true, false);
      this.leafNodes = leafNodes;
      // 在查出全选节点和子节点
      const allCheckAndLeafNodes = this.$refs.tree.getCheckedNodes(
        false,
        false,
      );
      // 在查出半选节点、全选节点、子节点
      const allNodes = this.$refs.tree.getCheckedNodes(false, true);
      // 筛选出全选节点(不包括叶子节点)
      const allCheckNodes = allCheckAndLeafNodes.filter(
        (node) => !leafNodes.includes(node),
      );
      this.allCheckNodes = allCheckNodes;
      // 筛选出半选节点
      const halfNodes = allNodes.filter(
        (node) => !allCheckAndLeafNodes.includes(node),
      );

      // 全选节点中筛选需要的节点
      // eslint-disable-next-line no-restricted-syntax
      for (const searchNode of allCheckNodes) {
        const isFind = this.searchRootNodes(allCheckNodes, searchNode);
        if (!isFind) {
          this.needValue.push(searchNode);
        }
      }

      this.searchLeafNodes(halfNodes, leafNodes);
      this.upname = [];
      this.upid = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of this.needValue) {
        // console.log(item.label)
        this.upname.push(item.label);
        this.upid.push(item.resId);
      }
    },
    // 递归调用筛选需要的叶子节点
    searchLeafNodes(halfNodes, leafNodes) {
      // eslint-disable-next-line no-restricted-syntax
      for (const halfNode of halfNodes) {
        // 如果存在子子节点
        if (!halfNode.children.children) {
          // 查找子节点下是否存在某个叶子节点，如果存在就是需要的节点
          halfNode.children.forEach((node) => {
            if (leafNodes.includes(node)) {
              this.needValue.push(node);
            }
          });
        } else {
          // 递归
          this.searchLeafNodes(halfNode.children, leafNodes);
        }
      }
    },
    // 递归调用判断全选节点中查找的节点是否为顶级节点
    searchRootNodes(allCheckNodes, searchNode) {
      // eslint-disable-next-line no-restricted-syntax
      for (const allCheckNode of allCheckNodes) {
        if (!allCheckNode.children.children) {
          if (allCheckNode.children.includes(searchNode)) {
            return true;
          }
        } else {
          return this.searchRootNodes(allCheckNodes);
        }
      }
      return false;
    },
    handleClear() {
      // 将选择器的值置空
      this.upResName = '';
      this.upResId = '';
      this.upid = [];
    },
  },
  watch: {
    treeData(newV) {
      this.data[0].children = newV;
    },
    upname() {
      this.upResName = String(this.upname);
    },

    upid() {
      this.upResId = String(this.upid);
      this.sendSelect();
      this.sendSelectstate();
      this.sendSelectYezi();
    },
  },
};
</script>
<style scoped>
</style>
